import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Person from "./pages/Person";
import Chat from "./pages/Chat";

function App() {

  return (
      <Router basename="/">
        <div className="App" >
          <Routes >
            <Route path="/carboncopydating" element={<Home />} />
            <Route path="/carboncopydating/person/:id" element={<Person />} />
              <Route path="/carboncopydating/chat/:id" element={<Chat />} />
            <Route path="*" element={<Navigate to="/carboncopydating"/>} />
          </Routes>
        </div>
      </Router>
  );
}

export default App;
